import styled from 'styled-components';
import { Text } from '@lux/text';
export const StyledText = styled(Text).withConfig({ displayName: "StyledText", componentId: "sc-b8r9t0" }) `margin:0;`;
//# sourceMappingURL=styles.js.map